<mat-sidenav-container>

  <div id="fuse-main-content">

    <!-- TOOLBAR: Above -->
    @if (fuseSettings.layout.toolbar === 'above') {
      <fuse-toolbar class="above" [ngClass]="fuseSettings.colorClasses.toolbar"
      [style.background-color]="backgroundColor"></fuse-toolbar>
    }
    <!-- / TOOLBAR: Above -->

    <!-- NAVBAR: Top -->
    @if (fuseSettings.layout.navigation === 'top') {
      <fuse-navbar-horizontal class="top-navbar" fxHide fxShow.gt-md
        [ngClass]="fuseSettings.colorClasses.navbar"
        >
      </fuse-navbar-horizontal>
    }
    <!-- / NAVBAR: Top -->

    <div id="wrapper">

      <!-- NAVBAR: Left -->
      @if (fuseSettings.layout.navigation === 'left' || fuseSettings.layout.navigation === 'top') {
        <fuse-navbar-vertical [folded]="fuseSettings.layout.navigationFolded"
          class="left-navbar"
          [ngClass]="fuseSettings.colorClasses.navbar"
          >
        </fuse-navbar-vertical>
      }
      <!-- / NAVBAR: Left -->

      <div class="content-wrapper">

        <!-- TOOLBAR: Below -->
        @if (fuseSettings.layout.toolbar === 'below') {
          <fuse-toolbar class="below" [ngClass]="fuseSettings.colorClasses.toolbar"
          [style.background-color]="backgroundColor"></fuse-toolbar>
        }
        <!-- / TOOLBAR: Below -->

        <fuse-content></fuse-content>

        <!-- FOOTER: Below -->
        @if (fuseSettings.layout.footer === 'below') {
        }
        <!-- / FOOTER: Below -->

      </div>

      <!-- NAVBAR: Right -->
      @if (fuseSettings.layout.navigation === 'right') {
        <fuse-navbar-vertical [folded]="fuseSettings.layout.navigationFolded"
          class="right-navbar"
          [ngClass]="fuseSettings.colorClasses.navbar"
          >
        </fuse-navbar-vertical>
      }
      <!-- / NAVBAR: Right -->

    </div>

    <!-- FOOTER: Above -->
    @if (fuseSettings.layout.footer === 'above') {
    }
    <!-- FOOTER: Above -->

  </div>

  <!-- QUICK PANEL -->
  <mat-sidenav [fuseMatSidenavHelper]="'quick-panel'" position="end">
    <fuse-quick-panel></fuse-quick-panel>
  </mat-sidenav>
  <!-- / QUICK PANEL -->

</mat-sidenav-container>

<!--<fuse-theme-options></fuse-theme-options>-->



